import { CancellationToken } from "../Promises/CancellationTokenSource";
/**
 * Rozhraní umožnující číst obecný proud dat
 */
export interface IStreamReader {
    /**
     * Celková velikost dat streamu
     */
    readonly size: number | null;

    /**
     * Přečte blok dat ze streamu
     * @param start Počáteční pozice čtení (od kterého bytu se má začít číst) nebo undefined pro čtení od začátku
     * @param end Koncová pozice čtení (do kterého posledního bytu se má číst - včetně) nebo undefined pro čtení do konce streamu
     * @returns Přečtená binární data
     */
    read(start?: number, end?: number, cancellationToken?: CancellationToken): Promise<ArrayBuffer>;
}
